export function isElementDescendantOfElement(parentElement, childElement) {
    if (!parentElement) {
        return false;
    }
    if (parentElement === childElement) {
        return true;
    }
    if (!childElement || !('parentNode' in childElement)) {
        return false;
    }
    let node = childElement.parentNode;
    while (node) {
        if (node === parentElement) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}
export function formatUrl(option) {
    const scheme = option.scheme || 'http:';
    const host = option.host || 'localhost';
    const port = option.port;
    const pathPrefix = option.pathPrefix || '';
    const path = option.path || '';
    return `${scheme}//${host}${port ? `:${port}` : ''}${pathPrefix}${path}`;
}
export function isElementDescendantOfElementWithClass(element, className) {
    var _a;
    if (!element) {
        return false;
    }
    if ('classList' in element && element.classList.contains(className)) {
        return true;
    }
    if (!('parentNode' in element)) {
        return false;
    }
    let node = element.parentNode;
    while (node) {
        if ((_a = node === null || node === void 0 ? void 0 : node.classList) === null || _a === void 0 ? void 0 : _a.contains(className)) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}
export function isChildOfSelector(element, parentSelector) {
    let node = element.parentNode;
    while (node) {
        if (typeof node.matches !== 'undefined' && node.matches(parentSelector)) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}
export function isFocused(el) {
    return el === document.activeElement;
}
/**
 * Zero width joints are used for joining spans that are separated. In Arabic, Hindi and Emoji text, glyphs that are in separate
 * spans are rendered as separate instead of continous joined text. The glyphs changes a bit when they are separated vs joined.
 * In order to support Character Styles, we have to include zero-width joint character u+200D and zero-width-no-joint u+200C
 * character, to signal that a text is joined.
 */
export function getStringByExcludingZeroWidthJoints(node) {
    return node.textContent.replace(/\u200C/g, '').replace(/\u200D/g, '');
}
export function getXmlElement(element, tag) {
    const child = element.querySelector(tag);
    if (!child) {
        throw new Error(`No ${tag} found in the ${element.tagName}`);
    }
    return child;
}
export function getXmlAttribute(element, attribute) {
    const value = element.getAttribute(attribute);
    if (!value) {
        throw new Error(`No ${attribute} attribute found in the ${element.tagName}`);
    }
    return value;
}
